import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import managementService from '../../services/AdminManagementService';
import { Grid, Typography, CircularProgress, Button } from '@mui/material';

export default function ContentLoadingRedirect() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState('');
    
    const getContentAppTicket = async() => {
        setIsLoading(true);
        const contentAppTicket = await managementService.getContentLoginTicket();

        if(contentAppTicket) {
            setIsLoading(false);
            window.location.replace(`${process.env.REACT_APP_BEABLE_CONTENT_WEBAPP_URL}/login/adminAccount/${contentAppTicket}`);
        } else {
            setIsLoading(false);
            setIsError(true);
            setError("Sorry, we could not redirect you! Please contact support!")
        }
            
    }

    useEffect(() => {
        getContentAppTicket();
    }, [])

    return (
        <>
            <Header />
            <Grid sx={{ textAlign:'center' }} size={12}>
                <Typography variant='h4'>{isError ? error : "Redirecting to Content Loader App..."}</Typography>
                {isLoading ? <CircularProgress test-id="batch-loader" disableShrink /> : null}
                {isError ? <Button onClick={getContentAppTicket}>Return</Button> : null}
            </Grid>
        </>
    );
}